const isProduction = process.env.REACT_APP_WEB_MODE === "production";

export const FIRESTORE_PATH = {
  invitation: {
    root: isProduction ? "production-invitation" : "development-invitation",
    path: isProduction ? "production-invitation/" : "development-invitation/",
  },
};
